import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchProducts } from '../requests';
import Product from '../components/Product';
import MoreProductDetails, { hasMoreProductDetails } from '../components/MoreProductDetails';
import ProductInfo from '../components/ProductInfo';
import DaneModeluNaOfercie from '../components/DaneModeluNaOfercie';
import BreadcrumbsComponent from '../components/Breadcrumbs';
import Loader from '../components/Loader';
import { ZachetyWMarginesach, ZachetyWTresci } from '../components/promo/ZachetyModelu';
import useDocumentTitle from '../hooks/useDocumentTitle';

const PanelDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  // Nazwa doczytuje sie z API, wiec do czasu odpowiedzi
  // zakladka pokazuje kategorie zamiast golego „VoltValue".
  useDocumentTitle(product?.name || 'Moduł PV');
  const [model, setModel] = useState(null);
  const [otherOffers, setOtherOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { window.scrollTo(0, 0); }, [id]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      const data = await fetchProducts(`get_panel/${id}`);
      if (cancelled) return;
      setProduct(data && !data.error ? data : null);
      setLoading(false);

      // Model tego samego produktu: inne oferty ORAZ scalone dane, parametry
      // elektryczne, karta katalogowa i opis (patrz DaneModeluNaOfercie).
      if (data && data.model_id != null) {
        const m = await fetchProducts(`get_panel_model/${data.model_id}`);
        if (cancelled) return;
        setModel(m && !m.error ? m : null);
        const offers = (m && m.offers) || [];
        setOtherOffers(offers.filter((o) => String(o.id) !== String(id)));
      } else {
        setModel(null);
        setOtherOffers([]);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [id]);

  if (loading) {
    return (
      <div className='fixed inset-0 flex justify-center items-center'>
        <Loader />
      </div>
    );
  }

  if (!product) {
    return <div className="px-4 lg:px-24 mt-10 text-gray-500">Nie znaleziono produktu.</div>;
  }

  const showMoreDetails = hasMoreProductDetails(product);

  return (
    <div className="relative">
      {/* Zachęty dalej, jak na karcie modelu (2026-10-08): w marginesach od 1840 px, węższe ekrany na dole strony. */}
      <ZachetyWMarginesach kategoria="panel" modelId={product.model_id} />
      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-10">
        <BreadcrumbsComponent parentLabel="Moduły PV" parentTo="/panele" currentLabel={product.name} />
      </div>

      <ProductInfo product={product} productType="panel" />
      <DaneModeluNaOfercie model={model} category="panel" />
      {/* „Informacje szczegółowe" tylko dla ofert BEZ modelu. Gdy model jest,
          sekcja „Dane produktu" wyżej pokazuje to samo, tylko scalone ze wszystkich
          ofert — czyli pełniej. Dwie tabele z wymiarami i gwarancją jedna pod drugą
          różniłyby się kompletnością i wyglądałyby na sprzeczne. */}
      {!model && showMoreDetails && <MoreProductDetails product={product} />}

      {otherOffers.length > 0 && (
        <div className="max-w-5xl mx-auto px-4 md:px-8 mb-16">
          <h2 className="text-lg sm:text-xl font-bold text-blue-600 mb-4">
            Inne oferty tego produktu <span className="text-blue-400 font-normal">({otherOffers.length})</span>
          </h2>
          <ul>
            {otherOffers.map((o) => (
              <Product key={o.id} product={o} productType="panel" compact />
            ))}
          </ul>
        </div>
      )}
      <div className="max-w-5xl mx-auto px-4 md:px-8 mb-16">
        <ZachetyWTresci kategoria="panel" modelId={product.model_id} />
      </div>
    </div>
  );
};

export default PanelDetails;
